module.exports = __webpack_public_path__ + "img/dept-11.fbfd0675.svg";